import { formatToPageHeadline } from 'helpers/date';
import Logo from 'components/atoms/Logo/Logo';
import { Translate } from 'next-translate';

interface GetPdfContentProps {
  items: any;
  date: string | undefined;
}

interface ItemsByCat {
  [key: string]: any[];
}

export const getPdfData = (
  { items, date }: GetPdfContentProps,
  t: Translate
): JSX.Element => {
  const safeItems = Array.isArray(items) ? items : [];
  const dailyPlanLabel = t('dailyPlan').replace('TagesPlan', 'Tagesplan');
  const maxItemsPerPage = 30;

  const itemsByCat: ItemsByCat = {};

  safeItems.forEach((item: any) => {
    const category = item?.category || 'all';

    if (!itemsByCat[category]) {
      itemsByCat[category] = [];
    }

    itemsByCat[category].push(item);
  });

  const preferredOrder = ['all', 'Veranstaltung', 'Mitmachaktivitaet', 'Handwerk'];

  const pages: Array<{
    tables: Array<{ key: string; rows: any[] }>;
    rowCount: number;
  }> = [{ tables: [], rowCount: 0 }];

  Object.keys(itemsByCat)
    .filter((key) => itemsByCat[key].length > 0)
    .sort((a, b) => {
      const idxA = preferredOrder.indexOf(a);
      const idxB = preferredOrder.indexOf(b);
      const orderA = idxA >= 0 ? idxA : preferredOrder.length;
      const orderB = idxB >= 0 ? idxB : preferredOrder.length;
      return orderA - orderB;
    })
    .forEach((key) => {
      const rows = itemsByCat[key];
      let index = 0;

      while (index < rows.length) {
        let currentPage = pages[pages.length - 1];

        if (currentPage.rowCount >= maxItemsPerPage) {
          currentPage = { tables: [], rowCount: 0 };
          pages.push(currentPage);
        }

        const remaining = maxItemsPerPage - currentPage.rowCount;
        const slice = rows.slice(index, index + remaining);

        currentPage.tables.push({ key, rows: slice });
        currentPage.rowCount += slice.length;
        index += slice.length;
      }
    });

  const renderHouseNr = (item: any) => {
    const houseNr = item.termin?.location?.house_nr;
    if (houseNr != null && houseNr !== '') return houseNr;
    return '–';
  };


  return (
    <>
      {pages.map((page, pageIndex) => (
        <div
          key={`page-${pageIndex}`}
          className={`pdf-page${pageIndex < pages.length - 1 ? ' pdf-page-break' : ''}`}
        >
          <div className="logo-wrapper">
            <Logo />
          </div>

          <h1>
            {dailyPlanLabel} {date && formatToPageHeadline(date)}
          </h1>

          {page.tables.map((table, tableIndex) => (
            <table key={`table-${table.key}-${pageIndex}-${tableIndex}`}>
              <thead>
                <tr>
                  <th>{t(table.key === 'all' ? 'allCategories' : table.key)}</th>
                  <th>{t('houseNr')}</th>
                  <th>{t('time')}</th>
                </tr>
              </thead>

              <tbody>
                {table.rows.map((item, rowIndex) => (
                  <tr key={`row-${table.key}-${pageIndex}-${tableIndex}-${rowIndex}`}>
                    <td>{item.display_name}</td>
                    <td>{renderHouseNr(item)}</td>
                    <td>{item.termin?.timeslot ?? '–'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ))}
        </div>
      ))}
    </>
  );
};
